import { isNotNull } from "@faire/web--source/common/typescriptUtils";
import { matchPath } from "react-router-dom";
import { removeLocaleFromUrl } from "./util";
export var matchPathWithLocale = function(pathWithLocal, route) {
    return isNotNull(matchPath(removeLocaleFromUrl(pathWithLocal), {
        path: route
    }));
};
